// ValidatedList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container, Typography, Alert, Box, Avatar, Chip, Stack
} from "@mui/material";

const getInitials = (prenom, nom) =>
  `${prenom ? prenom[0] : ""}${nom ? nom[0] : ""}`.toUpperCase();

const StatusChip = ({ statut }) => (
  <Chip
    label={statut.charAt(0).toUpperCase() + statut.slice(1)}
    style={{
      background: "#e9f9ef",
      color: "#22c55e",
      fontWeight: 700,
      border: "1.2px solid #22c55e"
    }}
    size="small"
  />
);

function ValidatedList() {
  const [demandes, setDemandes] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDemandes = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) {
          setError("Utilisateur non authentifié");
          return;
        }
        const response = await axios.get("https://appapi.unpaidfinancial.com/api/demandes", {
          headers: { Authorization: `Bearer ${token}` },
        });
        // On ne garde que les validées
        setDemandes(response.data.filter(d =>
          /valid|accept/i.test(d.statut)
        ));
      } catch (err) {
        setError("Erreur lors de la récupération des demandes");
      }
    };
    fetchDemandes();
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 4, textAlign: "center" }}>
        Demandes validées
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {demandes.length === 0 && !error && (
        <Alert severity="info" sx={{ mt: 3, textAlign: "center" }}>
          Aucune demande validée pour le moment.
        </Alert>
      )}
      <Box sx={{
        borderLeft: "3px solid #22c55e44",
        pl: { xs: 0, sm: 4 },
        mt: 3
      }}>
        {demandes.map((demande, idx) => (
          <Stack
            key={demande.id}
            direction="row"
            alignItems="flex-start"
            spacing={2}
            sx={{ position: "relative", mb: 4 }}
          >
            {/* Avatar Timeline point */}
            <Avatar sx={{
              bgcolor: "#22c55e",
              color: "#fff",
              fontWeight: 700,
              width: 52,
              height: 52,
              position: "relative",
              left: "-30px",
              border: "3px solid #fff",
              boxShadow: "0 3px 8px rgba(34,197,94,0.14)",
              zIndex: 1
            }}>
              {getInitials(demande.prenom, demande.nom)}
            </Avatar>
            {/* Info */}
            <Box sx={{
              background: "#e9f9ef",
              borderRadius: 2,
              p: 2.2,
              boxShadow: "0 4px 16px 0 rgba(34,197,94,0.04)",
              minWidth: 0,
              flexGrow: 1
            }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#1f5131" }}>
                  {demande.nom} {demande.prenom}
                </Typography>
                <StatusChip statut={demande.statut} />
              </Stack>
              <Typography variant="body2" sx={{ color: "#299e64", mt: 0.5 }}>
                {demande.email} {demande.telephone && `| ${demande.telephone}`}
              </Typography>
             
                <Typography variant="body2" sx={{ color: "#156548", mt: 0.5 }}>
                  <strong>Sexe :</strong> {demande.sexe}
                </Typography>

                <Typography variant="body2" sx={{ color: "#156548", mt: 0.5 }}>
                  <strong>Date de Naissance :</strong> {demande.dateNaissance}
                </Typography>

                <Typography variant="body2" sx={{ color: "#156548", mt: 0.5 }}>
                  <strong>Type d'Aide :</strong> {demande.typeAide}
                </Typography>

                <Typography variant="body2" sx={{ color: "#156548", mt: 0.5 }}>
                  <strong>Adresse résidentielle :</strong> {demande.adresse}
                </Typography>
              
              {demande.montantDemande &&
                <Typography variant="body2" sx={{ color: "#167d45", mt: 0.5 }}>
                  <strong>Montant : </strong>{demande.montantDemande} {demande.devise}
                </Typography>
              }
              {demande.ville || demande.pays ? (
                <Typography variant="body2" sx={{ color: "#166a3c", mt: 0.5 }}>
                  <strong>Lieu : </strong>{demande.ville} {demande.pays && `, ${demande.pays}`}
                </Typography>
              ) : null}
              {demande.projetDescription && (
                <Typography variant="body2" sx={{ color: "#156548", mt: 0.5 }}>
                  <strong>Projet :</strong> {demande.projetDescription}
                </Typography>
              )}
            </Box>
          </Stack>
        ))}
      </Box>
    </Container>
  );
}
export default ValidatedList;
